// Limpa nome/valor da variante
function clearVarTxt(txt) {
  let newTxt = removeEmojis(txt);
  newTxt = newTxt.replace(/\s+/g, ' ');
  newTxt = newTxt.replace(/[^a-zA-Z0-9\u00C0-\u00FF!()% _?/.]/g, '');
  return newTxt;
}

// Limpa o título das variantes e itens
$('body').on('change input', '.var-title-clear', function () {
  $(this).val(clearVarTxt($(this).val()));
});

$('.variante-opcao .bootstrap-tagsinput input').on('change input', function () {
  $(this).val(clearVarTxt($(this).val()));
});

// Gera uma SKU aleatório
(function () {
  'use strict';

  // Variáveis
  const $btnSKU = $('.generate-sku');

  // Evento de clique no botão de gerar o código
  $btnSKU.on('click', function (ev) {
    ev.preventDefault();

    const $campoSKU = $($(this).data('input'));
    $campoSKU.parsley().reset();
    $campoSKU.val(generateString(9).toUpperCase()).trigger('change');
  });
})();

// Categorias
(function () {
  'use strict';

  if ($('.form-produtos').length > 0) {
    const $categoriesList = $('#categories-list');
    const $tableCategories = $categoriesList.find('table');
    const $categoriesId = $('#categories_id');
    const textoLista = {
      empty: 'Nenhuma categoria encontrada.',
    };
    const htmlLinha = (item, isCategory = false) => `
    <tr data-row="${item['id']}" ${isCategory == false ? `data-category-id="${item['subcategory_of']}"` : ''}>
      <td class="category-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="check-row-categorias-${item['id']}" class="check-row" value="${
      item['id']
    }">
          <label for="check-row-categorias-${item['id']}" title="Selecionar item"><span ${
      isCategory ? `style="font-weight: 600; padding-left: 5px;"` : 'style="padding-left: 5px;"'
    }>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Título" ${isCategory ? `style="font-weight: 600;"` : 'style="padding-left: 25px;"'}>
        ${item['title']}
      </td>
    </tr>
    `;

    function beforeBuscaCategorias() {
      $tableCategories.find('tbody').html('');
      $tableCategories.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaCategorias() {
      beforeBuscaCategorias();
      const url = $categoriesId.data('url');
      const data = {
        acao: 'busca_categorias',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaCategorias()
      .done((result) => {
        if (result.total > 0) {
          $tableCategories.find('tbody').html('');
          result['categorias'].forEach(function (item) {
            $tableCategories.find('tbody').append(htmlLinha(item, true));
            if (item['subcategorias'].length > 0) {
              item['subcategorias'].forEach(function (subcategoria) {
                $tableCategories.find('tbody').append(htmlLinha(subcategoria, false));
              });
            }
            $tableCategories.find('tbody').find('input[type="checkbox"]').on('change', eventSelectCategory);
          });
        } else {
          $tableCategories.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaCategorias);

    function afterBuscaCategorias() {
      selecionaSelecionados();

      // Evento click na tabela
      $tableCategories.find('tr').on('click', tableRowClick);
    }

    function selecionaSelecionados() {
      if ($categoriesId.length > 0) {
        const ids = $categoriesId.val().split(',');
        ids.forEach(function (id) {
          $tableCategories.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
        });
        atualizaCheckbox();
      }
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let categoriasId = [
        ...new Set(
          $tableCategories
            .find(`tr[data-category-id]`)
            .toArray()
            .map((tr) => tr.dataset['categoryId']),
        ),
      ];
      categoriasId.forEach(function (categoryId) {
        const $rowCategory = $tableCategories.find('tbody').find(`[data-row="${categoryId}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableCategories
          .find('tbody')
          .find(`[data-category-id="${categoryId}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableCategories.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $categoriesId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectCategory(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('category-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Coleções
(function () {
  'use strict';

  if ($('.form-produtos').length > 0) {
    const $colecoesList = $('#colecoes-list');
    const $tableColecoes = $colecoesList.find('table');
    const $colecoesId = $('#colecoes_id');
    const textoLista = {
      empty: 'Nenhuma coleção encontrada.',
    };
    const htmlLinha = (item) => `
    <tr data-row="${item['id']}">
      <td class="colecao-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="check-row-colecoes-${item['id']}" class="check-row" value="${item['id']}">
          <label for="check-row-colecoes-${item['id']}" title="Selecionar item"><span>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Título">
        ${item['title']}
      </td>
    </tr>
    `;

    function beforeBuscaColecoes() {
      $tableColecoes.find('tbody').html('');
      $tableColecoes.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaColecoes() {
      beforeBuscaColecoes();
      const url = $colecoesId.data('url');
      const data = {
        acao: 'busca_colecoes',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaColecoes()
      .done((result) => {
        if (result.total > 0) {
          $tableColecoes.find('tbody').html('');
          result['colecoes'].forEach(function (item) {
            console.log(item);
            $tableColecoes.find('tbody').append(htmlLinha(item));
            $tableColecoes.find('tbody').find('input[type="checkbox"]').on('change', eventSelectColecao);
          });
        } else {
          $tableColecoes.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaColecoes);

    function afterBuscaColecoes() {
      selecionaSelecionados();

      // Evento click linha na tabela
      $tableColecoes.find('tr').on('click', tableRowClick);
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    function selecionaSelecionados() {
      if ($colecoesId.length > 0) {
        const ids = $colecoesId.val().split(',');
        ids.forEach(function (id) {
          $tableColecoes.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
        });
        atualizaCheckbox();
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let colecoesId = [
        ...new Set(
          $tableColecoes
            .find(`tr[data-colecao-id]`)
            .toArray()
            .map((tr) => tr.dataset['colecaoId']),
        ),
      ];
      colecoesId.forEach(function (colecaoId) {
        const $rowCategory = $tableColecoes.find('tbody').find(`[data-row="${colecaoId}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableColecoes
          .find('tbody')
          .find(`[data-colecao-id="${colecaoId}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableColecoes.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $colecoesId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectColecao(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('category-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Selos
(function () {
  'use strict';

  if ($('.form-produtos').length > 0) {
    const $selosList = $('#selos-list');
    const $tableSelos = $selosList.find('table');
    const $selosId = $('#selos_id');
    const textoLista = {
      empty: 'Nenhum selo encontrado.',
    };
    const htmlLinha = (item) => `
    <tr data-row="${item['id']}">
      <td class="colecao-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="selo-row-${item['id']}" class="check-row" value="${item['id']}">
          <label for="selo-row-${item['id']}" title="Selecionar item"><span>${item['titulo']}</span></label>
        </div>
      </td>
      <td data-label="Título">
        <label for="selo-row-${item['id']}">${item['titulo']}</label>
      </td>
    </tr>
    `;

    function beforeBuscaSelos() {
      $tableSelos.find('tbody').html('');
      $tableSelos.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaSelos() {
      beforeBuscaSelos();
      const url = $selosId.data('url');
      const data = {
        acao: 'busca_selos',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaSelos()
      .done((result) => {
        if (result.total > 0) {
          $tableSelos.find('tbody').html('');
          result['selos'].forEach(function (item) {
            $tableSelos.find('tbody').append(htmlLinha(item));
            $tableSelos.find('tbody').find('input[type="checkbox"]').on('change', eventSelectSelos);
          });
        } else {
          $tableSelos.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaColecoes);

    function afterBuscaColecoes() {
      selecionaSelecionados();

      // Registra evento de click de linha
      $tableSelos.find('tr').on('click', tableRowClick);
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    function selecionaSelecionados() {
      if ($selosId.length > 0) {
        const ids = $selosId.val().split(',');
        ids.forEach(function (id) {
          if (id) {
            $tableSelos.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
          }
        });
        atualizaCheckbox();
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let selosId = [
        ...new Set(
          $tableSelos
            .find(`tr[data-selo-id]`)
            .toArray()
            .map((tr) => tr.dataset['seloId']),
        ),
      ];
      selosId.forEach(function (selo) {
        const $rowCategory = $tableSelos.find('tbody').find(`[data-row="${selo}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableSelos
          .find('tbody')
          .find(`[data-selo-id="${selo}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableSelos.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $selosId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectSelos(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('selo-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Filtros
(function () {
  'use strict';

  if ($('.form-produtos').length > 0) {
    const $filtros = $('#filtros-list');
    const $tableFiltros = $filtros.find('table');
    const $filtrosId = $('#filtros_id');
    const textoLista = {
      empty: 'Nenhum selo encontrado.',
    };
    const htmlLinha = (item) => `
    <tr data-row="${item['id']}">
      <td class="colecao-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="selo-row-${item['id']}" class="check-row" value="${item['id']}">
          <label for="selo-row-${item['id']}" title="Selecionar item"><span>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Título">
        <label for="selo-row-${item['id']}">${item['title']}</label>
      </td>
    </tr>
    `;

    function beforeBuscaFiltros() {
      $tableFiltros.find('tbody').html('');
      $tableFiltros.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaFiltros() {
      beforeBuscaFiltros();
      const url = $filtrosId.data('url');
      const data = {
        acao: 'busca_filtros',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaFiltros()
      .done((result) => {
        if (result.total > 0 && result.filtros.filter((item) => item.items.length > 0).length > 0) {
          $tableFiltros.find('tbody').html('');
          result['filtros']
            .filter((item) => item.items.length > 0)
            .forEach(function (item) {
              item.items.forEach((filterItem) => {
                const ObjFiltro = {
                  title: `${item.title} > ${filterItem.title}`,
                  id: `${item.id}|${filterItem.id}`,
                };
                $tableFiltros.find('tbody').append(htmlLinha(ObjFiltro));
                $tableFiltros.find('tbody').find('input[type="checkbox"]').on('change', eventSelectSelos);
              });
            });
        } else {
          $tableFiltros.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaColecoes);

    function afterBuscaColecoes() {
      selecionaSelecionados();

      // Registra evento de click de linha
      $tableFiltros.find('tr').on('click', tableRowClick);
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    function selecionaSelecionados() {
      if ($filtrosId.length > 0) {
        const ids = $filtrosId.val().split(',');
        ids.forEach(function (id) {
          if (id) {
            $tableFiltros.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
          }
        });
        atualizaCheckbox();
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let filtrosId = [
        ...new Set(
          $tableFiltros
            .find(`tr[data-filtro-id]`)
            .toArray()
            .map((tr) => tr.dataset['filtroId']),
        ),
      ];
      filtrosId.forEach(function (selo) {
        const $rowCategory = $tableFiltros.find('tbody').find(`[data-row="${selo}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableFiltros
          .find('tbody')
          .find(`[data-filtro-id="${selo}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableFiltros.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $filtrosId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectSelos(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('selo-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Customizações
(function () {
  'use strict';

  if ($('.form-produtos, #customizacao-list').length > 0) {
    const $customizacaoList = $('#customizacao-list');
    const $tableCustomizacao = $customizacaoList.find('table');
    const $customizacaoId = $('#customizacao_ids');
    const $cardWrapper = $('.customizacoes-wrp');
    const $inputSwitchCustom = $('input[name="custom"]');
    const textoLista = {
      empty: 'Nenhuma customização encontrada.',
    };
    const htmlLinha = (item) => `
    <tr data-row="${item['id']}">
      <td class="colecao-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="customizacao-row-${item['id']}" class="check-row" value="${item['id']}">
          <label for="customizacao-row-${item['id']}" title="Selecionar item"><span>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Título">
        <label for="customizacao-row-${item['id']}">${item['title']}</label>
      </td>
    </tr>
    `;

    function startSwitchCustom() {
      if ($inputSwitchCustom.is(':checked')) {
        $cardWrapper.show();
      } else {
        $cardWrapper.hide();
      }
    }
    startSwitchCustom();

    $inputSwitchCustom.on('change', switchCustomChange);
    function switchCustomChange(ev) {
      if ($(this).is(':checked')) {
        $cardWrapper.show();
      } else {
        $cardWrapper.hide();
      }
    }

    function beforeBuscaCustomizacao() {
      $tableCustomizacao.find('tbody').html('');
      $tableCustomizacao.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaCustomizacao() {
      beforeBuscaCustomizacao();
      const url = $customizacaoId.data('url');
      const data = {
        acao: 'busca_customizacoes',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaCustomizacao()
      .done((result) => {
        if (result.total > 0) {
          $tableCustomizacao.find('tbody').html('');
          result['customizacoes'].forEach(function (item) {
            $tableCustomizacao.find('tbody').append(htmlLinha(item));
            $tableCustomizacao.find('tbody').find('input[type="checkbox"]').on('change', eventSelectSelos);
          });
        } else {
          $tableCustomizacao.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaCustomizacoes);

    function afterBuscaCustomizacoes() {
      selecionaSelecionados();

      // Registra evento de click de linha
      $tableCustomizacao.find('tr').on('click', tableRowClick);
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    function selecionaSelecionados() {
      if ($customizacaoId.length > 0) {
        const ids = $customizacaoId.val().split(',');
        ids.forEach(function (id) {
          if (id) {
            $tableCustomizacao.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
          }
        });
        atualizaCheckbox();
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let customizacoesId = [
        ...new Set(
          $tableCustomizacao
            .find(`tr[data-customizacao-id]`)
            .toArray()
            .map((tr) => tr.dataset['seloId']),
        ),
      ];
      customizacoesId.forEach(function (selo) {
        const $rowCategory = $tableCustomizacao.find('tbody').find(`[data-row="${selo}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableCustomizacao
          .find('tbody')
          .find(`[data-customizacao-id="${selo}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableCustomizacao.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $customizacaoId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectSelos(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('customizacao-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Variantes
(function () {
  'use strict';

  // Variáveis
  const $btnAddOpcao = $('[data-list-add="variants_options"]');
  const $listOpcoes = $('[data-list="variants_options"]');
  const $tableVariantes = $('.table-variantes');
  const $tableVariantesWrp = $('.table-variantes-wrp');
  const $listVariantes = $('[data-list="variantes_lista"]');
  const $modalVar = $('#modal-variante');
  const $formVar = $('#form-variante');
  const $formVarBtn = $formVar.find('.btn-submit');
  const $slug = $('#var_slug');
  const $sku = $('#var_sku');
  const $skuAliExpress = $('#var_aliexpress_sku');
  const $codigo_barras = $('#var_codigo_barras');
  const $estoque_automatico = $('#var_estoque_automatico');
  const $quantidade_estoque = $('#var_quantidade_estoque');
  const $valor_custo = $('#var_valor_custo');
  const $valor_venda = $('#var_valor_venda');
  const $valor_antigo = $('#var_valor_antigo');
  const $peso = $('#var_peso');
  const $largura = $('#var_largura');
  const $altura = $('#var_altura');
  const $comprimento = $('#var_comprimento');
  const $btnApplyAll = $('.var-btn-apply-all');
  const $campoJSON = $('#variantes_json');
  const $modalBadgesWrp = $('.modal-variante-badges-wrp');
  const $modalBadgesTitle = $modalBadgesWrp.find('h5');
  const $modalBadges = $('.modal-variante-badges');
  let listVariantesObj = [];
  let salvando = false;
  const $dzInfos = $('#dz_fotos_infos');
  const variantSkuPrefix = generateString(9).toUpperCase();
  const acaoForm =
    $('.form-produtos input[name="acao"]').length > 0 ? $('.form-produtos input[name="acao"]').val() : false;

  // Placeholers predefinidos
  const placesH = {
    0: {
      placeh1: 'Ex: Cor',
      placeh2: 'Ex: Preto, Azul, Verde',
    },
    1: {
      placeh1: 'Ex: Tamanho',
      placeh2: 'Ex: P, M, G',
    },
    2: {
      placeh1: 'Ex: Material',
      placeh2: 'Ex: Couro, Tecido',
    },
    3: {
      placeh1: 'Ex: Tamanho',
      placeh2: 'Ex: P, M, G',
    },
    4: {
      placeh1: 'Ex: Tamanho',
      placeh2: 'Ex: P, M, G',
    },
  };

  // Título das opções
  let opcoesTitulos = [];
  let opcoesValores = [];

  // Adiciona uma nova opção
  $btnAddOpcao.on('click', function (ev) {
    ev.preventDefault();
    const nextID = formListGenerateID($listOpcoes);
    const placeh1 = placesH[formListGetTotal($listOpcoes)].placeh1;
    const placeh2 = placesH[formListGetTotal($listOpcoes)].placeh2;
    const item = `
    <li class="variante-opcao border-bottom mb-3" data-item="${nextID}">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="d-md-none">Nome da opção</label>
            <input type="text" name="variants_options[${nextID}][title]" class="form-control var-title-clear tags_tit" maxlength="255" placeholder="${placeh1}" data-parsley-trigger="change">
          </div>
          <div class="form-group">
            <label>Tipo de campo <span class="lbl-help" data-toggle="tooltip" data-placement="top" title="Forma em que esta opção será exibida para o cliente escolher no momento da compra."><i class="las la-question-circle"></i></span></label>
            <select name="variants_options[${nextID}][tipo]" class="form-control tags_tipo" data-parsley-trigger="change">
              <option value="radio">Botão (Radio)</option>
              <option value="image">Imagem</option>
              <option value="select">Seleção (Simples)</option>
            </select>
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label class="d-md-none">Valores da opção</label>
            <input type="text" name="variants_options[${nextID}][variant_values]" class="form-control tags" placeholder="${placeh2}" data-parsley-trigger="change">
          </div>
        </div>
        <div class="col-md-1">
          <div class="list-item-remove">
            <button class="btn" data-toggle="tooltip" data-placement="top" title="Remover" data-remove="${nextID}"><i class="las la-trash"></i></button>
          </div>
        </div>
      </div>
    </li>`;
    if (!formListIsFull($listOpcoes)) {
      if (acaoForm === 'update') {
        showConfirm({
          type: 'warning',
          title: 'Confirmar Alteração',
          text: 'Deseja adicionar uma nova opção? Ao adicionar, todas as variantes já cadastradas para este produto serão recriadas com base nas novas opções!',
          confirmButtonText: 'Adicionar',
          cancelButtonText: 'Cancelar',
          callback: function () {
            formListAdd($listOpcoes, item);
            handleOptionsVarImage();
          },
        });
      } else {
        formListAdd($listOpcoes, item);
        handleOptionsVarImage();
      }
    }
  });

  // Só permite que apenas uma das opções seja do tipo imagem
  $listOpcoes.on('change', '.tags_tipo', handleOptionsVarImage);
  if ($('.tags_tipo option[value="image"]').length > 0) {
    handleOptionsVarImage();
  }
  function handleOptionsVarImage() {
    const $camposTipos = $listOpcoes.find('.tags_tipo');
    const $campoTipoImagem = $listOpcoes.find('.tags_tipo option[value="image"]:selected');
    if ($campoTipoImagem.length > 0) {
      $camposTipos.find('option[value="image"]').prop('disabled', true);
      $campoTipoImagem.parent('.tags_tipo').find('option[value="image"]').prop('disabled', false);
    } else {
      $camposTipos.find('option[value="image"]').prop('disabled', false);
    }
  }

  // Remove uma opção
  $listOpcoes.on('click', '.list-item-remove .btn', function (ev) {
    ev.preventDefault();
    //console.log('Opção removida!');
    const idItem = $(this).data('remove');
    if (acaoForm === 'update') {
      showConfirm({
        type: 'danger',
        title: 'Confirmar Remoção',
        text: 'Deseja remover esta opção? Ao remover, todas as variantes já cadastradas para este produto serão recriadas com base nas novas opções!',
        confirmButtonText: 'Remover',
        cancelButtonText: 'Cancelar',
        callback: function () {
          formListDel($listOpcoes, idItem);
          handleOptionsVarImage();
          updateVariantes();
        },
      });
    } else {
      formListDel($listOpcoes, idItem);
      handleOptionsVarImage();
      updateVariantes();
    }
  });

  // Impede que sejam adicionados valores repetidos (Maiúsculos ou minúsculos) ou caracteres inválidos
  $listOpcoes.on('beforeItemAdd', '.form-control.tags', function (ev) {
    const item = ev.item;
    let allow = true;
    $(this)
      .prev()
      .find('.tag')
      .each(function () {
        if ($(this).text().trim().toLowerCase() == item.toString().trim().toLowerCase()) {
          allow = false;
          return false;
        }
      });
    if (!allow) {
      ev.cancel = true;
    }
  });

  /* if (acaoForm === 'update') {
    $listOpcoes.on('beforeItemRemove', '.form-control.tags', function (ev) {
      const $input = $(this);
      const itemRemove = ev.item;
      showConfirm({
        type: 'danger',
        title: 'Confirmar Remoção',
        text: 'Deseja remover esta opção? Ao remover, todas as variantes já cadastradas para este produto serão recriadas com base nas novas opções!',
        confirmButtonText: 'Remover',
        cancelButtonText: 'Cancelar',
        callback: function () {
          $input.tagsinput('remove', itemRemove);
        },
      });
      ev.cancel = true;
    });
  } */

  // Ao clicar para alterar uma opção (Update)
  if (acaoForm === 'update') {
    /* $listOpcoes.on('click', '.form-control.tags_tit[readonly]', function () {
      const $input = $(this);
      showConfirm({
        type: 'warning',
        title: 'Confirmar Alteração',
        text: 'Deseja atualizar esta opção? Ao alterar, todas as variantes já cadastradas para este produto serão recriadas com base nos novos nomes das opções!',
        confirmButtonText: 'Atualizar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          $input.prop('readonly', false);
        },
      });
    }); */
  }

  // Atualiza o nome das opções
  $listOpcoes.on('change', '.form-control.tags_tit', function () {
    //getOpcoesTitulos();
    const $inputTitle = $(this);
    if ($inputTitle.val().trim() != '') {
      $inputTitle.removeClass('danger');
    }
    if (acaoForm === 'update') {
      const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
      const newTitle = $inputTitle.val().trim();
      const oldTitle = $inputTitle.data('old-title');
      if (newTitle) {
        const occurrencesArr = [];
        $listOpcoes.find('.variante-opcao').each(function () {
          const $item = $(this);
          const $campoTitulo = $item.find('input[name*="[title]"]');
          const titulo = $campoTitulo.val().trim();
          if (titulo != '') {
            occurrencesArr.push(slugify(titulo));
          }
        });
        if (countOccurrences(occurrencesArr, slugify(newTitle)) > 1) {
          $inputTitle.val('');
          $inputTitle.focus();
          Toast.fire({
            type: 'warning',
            title: 'Já existe uma opção como este mesmo título.',
          });
        } else {
          // Atualiza o parâmetros nos itens da opção (Update)
          $inputTitle.closest('.variante-opcao').find('.opt-var-itens-upd-item').data('opt', newTitle);
          $inputTitle.data('old-title', newTitle);
          updateItemTitleVariants('opt', oldTitle, newTitle);
        }
      } else {
        $inputTitle.focus();
        Toast.fire({
          type: 'warning',
          title: 'Digite um nome para a opção.',
        });
      }
    } else {
      updateVariantes();
    }
  });

  // Atualiza o nome de uma opção ou item das variantes
  function updateItemTitleVariants(changeType, oldItemTitle, newItemTitle, optTitle = false) {
    if (oldItemTitle && newItemTitle) {
      opcoesValores = getOpcoes();
      const oldItemTitleSlug = slugify(oldItemTitle);
      const newItemTitleSlug = slugify(newItemTitle);
      const optTitleSlug = optTitle ? slugify(optTitle) : '';
      if (changeType === 'opt') {
        const newListVariantesObj = listVariantesObj.map((variante) => {
          variante['slug'] = variante['slug'].replace(oldItemTitleSlug + ':', newItemTitleSlug + ':');
          variante['title'] = variante['title'].replace(oldItemTitle + ':', newItemTitle + ':');
          return variante;
        });
        listVariantesObj = newListVariantesObj;
        updateVariantesTable();
        salvarVariantes();
      } else if (changeType === 'item') {
        const findStr = optTitleSlug + ':' + oldItemTitleSlug;
        const replaceStr = optTitleSlug + ':' + newItemTitleSlug;
        /* const findStr2 = optTitle + ': ' + oldItemTitle;
        const replaceStr2 = optTitle + ': ' + newItemTitle; */
        const reSlug = new RegExp(`${findStr}\$`, 'g');
        //const reTitle = new RegExp(`${findStr2}\$`, 'g');
        const newListVariantesObj = listVariantesObj.map((variante) => {
          const varItemSlugArr = variante.slug.split('|');
          //const varItemTitleArr = variante.title.split(' / ');
          const varItemSlugArrNew = varItemSlugArr.map((varItemSlug) => {
            return varItemSlug.replace(reSlug, replaceStr);
          });
          /* const varItemTitleArrNew = varItemTitleArr.map((varItemTitle) => {
            return varItemTitle.replace(reTitle, replaceStr2);
          }); */
          const varItemSlugNew = varItemSlugArrNew.join('|');
          //const varItemTitleNew = varItemTitleArrNew.join(' / ');
          const varItemTitleNew = getVarTitView(varItemSlugNew);
          variante['slug'] = varItemSlugNew;
          variante['title'] = varItemTitleNew;
          return variante;
        });
        listVariantesObj = newListVariantesObj;
        updateVariantesTable();
        salvarVariantes();
      }
    }
  }

  // Ao adicionar um novo valor de opção de variante
  $listOpcoes.on('itemAdded', '.form-control.tags', function (ev) {
    //console.log('Valor adicionado!');
    updateVariantes();
  });
  $listOpcoes.on('change', '.tags_update', function () {
    //console.log('Valor adicionado!');
    updateVariantes();
  });

  // Ao remover um valor de opção de variante
  $listOpcoes.on('itemRemoved', '.form-control.tags', function (ev) {
    //console.log('Valor removido!');
    updateVariantes();
  });

  // Ao clicar em uma variante para editar
  $listVariantes.on('click', '[data-edit-variante]', function (ev) {
    ev.preventDefault();
    resetModalVariante();
    showModalVariante($(this).data('edit-variante'));
  });

  // Ao clicar para salvar uma variante
  $formVarBtn.on('click', function (ev) {
    ev.preventDefault();
    if (verifyVariantsSku($('#var_sku').val(), getVarianteIndex($slug.val()))) {
      if ($valor_venda.val() != '' && formatMoneyBD($valor_venda.val()) > 0) {
        if (!salvando) {
          $formVarBtn.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
          $formVar
            .parsley()
            .whenValidate()
            .done(function () {
              salvando = true;
              updateVariante();
              /* if (acaoForm == 'update') {
                const url = $('form.form-produtos').data('action');
                var formdata = $('form.form-produtos').serializeArray();
                const dataSend = {};
                $(formdata).each(function (index, obj) {
                  dataSend[obj.name] = obj.value;
                });
                dataSend['acao'] = 'variantes_update';
                $.ajax({
                  type: 'POST',
                  url: url,
                  data: dataSend,
                  dataType: 'json',
                });
              } */
            })
            .fail(function () {
              $formVarBtn.prop('disabled', false).html('Salvar');
            });
        }
      } else {
        Toast.fire({
          type: 'warning',
          title: 'Informe o preço de venda desta variante.',
        });
      }
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Já existe outro produto com este mesmo código de SKU.',
      });
    }
  });

  // Fix para o campo sku da variante
  if ($('#var_sku').length > 0) {
    $('#var_sku')
      .parsley()
      .on('field:validate', function () {
        if (!salvando) {
          $formVarBtn.prop('disabled', true);
        }
      })
      .on('field:validated', function () {
        if (!salvando) {
          $formVarBtn.prop('disabled', false);
        }
      });
  }

  // Ao alterar um campo do modal de variante (Exibe a opção de aplicar o valor para todas)
  function camposApplyAllEvent() {
    const $camposApplyAll = $('.var-apply-all');
    $camposApplyAll.on('change', function () {
      const $btnApply = $(`.var-btn-apply-all[data-input="${$(this).attr('name')}"]`);
      if (!$btnApply.hasClass('open')) {
        $btnApply.addClass('open');
        /* setTimeout(() => {
          $btnApply.removeClass('open');
        }, 5000); */
      }
    });
  }

  function hideApplyAll() {
    const $btnApplyAll = $('.var-btn-apply-all');
    $btnApplyAll.removeClass('open');
  }

  // Ao clicar para alterar a imagem da variante
  $listVariantes.on('click', 'img[data-handle-variante-img]', function (ev) {
    ev.preventDefault();
    const varianteSlug = $(this).data('handle-variante-img');
    $('#variante_img_slug').val(varianteSlug);
    $('#dz-gallery-variantes').find('input[name="variant_img"]').prop('checked', false);
    $('#modal-img-variante').modal('show');
  });

  // Ao clicar para aplicar a imagem da variante selecionada
  $('.btn-save-img-variante').on('click', function (ev) {
    ev.preventDefault();
    // Verifica se existe alguma foto selecionada
    if ($('#dz-gallery-variantes').find('input[name="variant_img"]:checked').length > 0) {
      const varianteSlug = $('#variante_img_slug').val();
      const fotoID = $('#dz-gallery-variantes').find('input[name="variant_img"]:checked').val();
      listVariantesObj[getVarianteIndex(varianteSlug)].image_id = fotoID;
      updateVariantesTable();
      salvarVariantes();
      $('#modal-img-variante').modal('hide');
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Selecione uma imagem para a variante.',
      });
    }
  });
  $dzInfos.on('change', updateVariantesTable);

  // Ao clicar na opção de aplicar o valor para todas as variantes
  $btnApplyAll.on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    if ($btn.hasClass('open')) {
      const inputName = $btn.data('input');
      const $input = $formVar.find(`[name="${inputName}"]`);
      if ($input.length > 0) {
        showConfirm({
          type: 'default',
          title: 'Confirmação',
          text: 'Deseja aplicar o valor para todas as variantes?',
          confirmButtonText: 'Aplicar',
          cancelButtonText: 'Cancelar',
          callback: function () {
            applyToAllVar(inputName, $input.val());
          },
        });
      }
    }
  });

  // Retorna a lista das opções com seus respectivos valores
  function getOpcoes() {
    const listOpcoes = [];
    $listOpcoes.find('.variante-opcao').each(function () {
      const $item = $(this);
      const $campoValores = $item.find('input[name*="[variant_values]"]');
      if ($campoValores.val() != '') {
        const valores = [];
        $campoValores
          .val()
          .split(',')
          .forEach((item) => {
            valores.push(item.trim());
          });
        listOpcoes.push(valores);
      }
    });
    getOpcoesTitulos();
    return listOpcoes;
  }

  // Resgata o título das opções
  function getOpcoesTitulos() {
    opcoesTitulos = [];
    let opcoesTitulosSlug = [];
    let semTitulo = 0;
    let mesmoTitulo = 0;
    const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    $listOpcoes.find('.variante-opcao').each(function () {
      const $item = $(this);
      const $campoTitulo = $item.find('input[name*="[title]"]');
      const titulo = $campoTitulo.val().trim();
      if (titulo != '') {
        opcoesTitulos.push(titulo);
        opcoesTitulosSlug.push(slugify(titulo));
        if (countOccurrences(opcoesTitulosSlug, slugify(titulo)) > 1) {
          mesmoTitulo++;
        }
      } else {
        semTitulo++;
        const semTituloCount = opcoesTitulos.length + 1;
        opcoesTitulos.push('Opção ' + semTituloCount);
      }
    });
    if (semTitulo > 0) {
      Toast.fire({
        type: 'warning',
        title: 'Por favor, digite um nome para a opção das variantes.',
      });
    }
    if (mesmoTitulo > 0) {
      Toast.fire({
        type: 'warning',
        title: 'Existe mais de uma opção de variante com o mesmo nome.',
      });
    }
  }

  // Gera todas as possíveis combinações de variantes
  /* function getCartesianArray(list) {
    const cartesianArray = [];
    if (list[0] && list[0].length > 0) {
      list[0].forEach(function (item) {
        if (list[1] && list[1].length > 0) {
          list[1].forEach(function (item2) {
            if (list[2] && list[2].length > 0) {
              list[2].forEach(function (item3) {
                cartesianArray.push(item + '|' + item2 + '|' + item3);
              });
            } else {
              cartesianArray.push(item + '|' + item2);
            }
          });
        } else {
          cartesianArray.push(item);
        }
      });
    }
    return cartesianArray;
  } */
  function getCartesianArray(list) {
    const cartesianArray = [];
    if (list[0] && list[0].length > 0) {
      list[0].forEach(function (item) {
        if (list[1] && list[1].length > 0) {
          list[1].forEach(function (item2) {
            if (list[2] && list[2].length > 0) {
              list[2].forEach(function (item3) {
                if (list[3] && list[3].length > 0) {
                  list[3].forEach(function (item4) {
                    if (list[4] && list[4].length > 0) {
                      list[4].forEach(function (item5) {
                        cartesianArray.push(item + '|' + item2 + '|' + item3 + '|' + item4 + '|' + item5);
                      });
                    } else {
                      cartesianArray.push(item + '|' + item2 + '|' + item3 + '|' + item4);
                    }
                  });
                } else {
                  cartesianArray.push(item + '|' + item2 + '|' + item3);
                }
              });
            } else {
              cartesianArray.push(item + '|' + item2);
            }
          });
        } else {
          cartesianArray.push(item);
        }
      });
    }
    return cartesianArray;
  }

  // Atualiza a lista de variantes
  function updateVariantes() {
    const opcoes = getOpcoes();
    opcoesValores = opcoes;
    const combinacoes = getCartesianArray(opcoes);
    const newListVariantesObj = [];
    combinacoes.forEach((comb, combIndex) => {
      const slugComb = geraSlugVariante(comb);
      if (listVariantesObj.some((item) => item.slug === slugComb)) {
        newListVariantesObj.push(getVariante(slugComb));
      } else {
        newListVariantesObj.push(addVariante(comb));
      }
    });
    listVariantesObj = newListVariantesObj;
    generateVariantsSku();
    updateVariantesTable();
    salvarVariantes();
  }

  // Popula a tabela de variantes
  function updateVariantesTable() {
    formListClear($listVariantes);
    if (listVariantesObj.length > 0) {
      $tableVariantesWrp.show();
    } else {
      $tableVariantesWrp.hide();
    }
    listVariantesObj.forEach((variante) => {
      const nextID = formListGenerateID($listVariantes);
      const tituloView = variante.title;
      const skuView = variante.sku ? variante.sku : '-';
      const qtdeView = variante.automatic_stock == '1' ? variante.quantity : '∞';
      const fotoView = getVarianteImg(variante.image_id);
      const valorView = 'R$ ' + formatMoneyBR(variante.sale_price);
      const $variante = `
      <tr data-item="${nextID}" data-variante="${variante.slug}">
        <td data-label="Foto"><img src="${fotoView}" class="img-fluid border rounded" data-handle-variante-img="${variante.slug}" width="50px"></td>
        <td data-label="Variante"><div class="variante-tit">${tituloView}</div></td>
        <td data-label="Preço">${valorView}</td>
        <td data-label="SKU"><div class="truncate-text" style="width: 100px;">${skuView}</div></td>
        <td data-label="Quantidade">${qtdeView}</td>
        <td>
          <div class="table-options no-hover">
            <a href="#" class="btn btn-sm btn-default" data-toggle="tooltip" data-placement="bottom" title="Editar" data-edit-variante="${variante.slug}"><i class="las la-pen"></i></a>
          </div>
        </td>
      </tr>`;
      $listVariantes.append($variante);
    });
    initTooltips();
    initInputMask();
    initSpinners();
    camposApplyAllEvent();
  }

  // Retorna a imagem da variante
  function getVarianteImg(fotoID) {
    let thumb = imgEmpty;
    if (fotoID && $dzInfos.val() != '') {
      let imagesList = $dzInfos.val();
      imagesList = JSON.parse(imagesList);
      let imgThumb = imagesList.filter((img) => img.id === fotoID);
      if (imgThumb.length > 0) {
        thumb = imgThumb[0].image_small;
      }
    }
    return thumb;
  }

  // Adiciona uma nova variante
  function addVariante(variante) {
    const slug = geraSlugVariante(variante);
    const varianteObj = {
      slug: slug,
      image_id: '',
      title: getVarTitView(slug),
      sku: '',
      aliexpress_sku: '',
      bar_code: '',
      automatic_stock: '0',
      quantity: '0',
      cost_price: 0.0,
      sale_price: 0.0,
      old_price: 0.0,
      weight: '',
      width: '',
      height: '',
      length: '',
    };
    return varianteObj;
  }

  // Gera um slug de uma variante
  function geraSlugVariante(variante) {
    const slugArr = [];
    variante.split('|').forEach((item, index) => {
      slugArr.push(slugify(opcoesTitulos[index]) + ':' + slugify(item));
    });
    return slugArr.join('|');
  }

  // Retorno o próximo número para criação dos SKU das variantes
  function generateVariantsSku() {
    let count = 0;
    listVariantesObj.forEach((item) => {
      count++;
      if (!item.sku || item.sku.includes(variantSkuPrefix)) {
        item.sku = variantSkuPrefix + ':' + count;
      }
    });
  }

  // Verifica se existe alguma variante com o mesmo SKU
  function verifyVariantsSku(sku, indexV) {
    return !listVariantesObj.some((item, index) => index !== indexV && item.sku === sku);
  }

  // Retorna a variante com base na combinação
  function getVariante(varianteSlug) {
    return listVariantesObj.filter((item) => item.slug === varianteSlug)[0];
  }

  // Retorna o índice de uma variante
  function getVarianteIndex(varianteSlug) {
    return listVariantesObj.findIndex((item) => item.slug === varianteSlug);
  }

  // Reseta o formulário do modal de edição da variante
  function resetModalVariante() {
    $slug.val('');
    $sku.val('');
    $skuAliExpress.val('');
    $codigo_barras.val('');
    $estoque_automatico.prop('checked', false).trigger('change');
    $quantidade_estoque.val('0');
    $valor_custo.val('');
    $valor_venda.val('');
    $valor_antigo.val('');
    $peso.val('');
    $largura.val('');
    $altura.val('');
    $comprimento.val('');
    $formVar.parsley().reset();
    hideApplyAll();
  }

  // Exibe o modal para alteração das informações da variante
  function showModalVariante(varianteSlug) {
    const variante = getVariante(varianteSlug);
    //console.log(variante);
    $slug.val(variante.slug);
    $sku.val(variante.sku);
    $skuAliExpress.val(variante.aliexpress_sku);
    $codigo_barras.val(variante.bar_code);
    $estoque_automatico.prop('checked', variante.automatic_stock == '1').trigger('change');
    $quantidade_estoque.val(variante.quantity);
    $valor_custo.val(formatMoneyBR(variante.cost_price));
    $valor_venda.val(formatMoneyBR(variante.sale_price));
    $valor_antigo.val(formatMoneyBR(variante.old_price));
    if (isNaN(variante.weight)) {
      $peso.val(variante.weight);
    } else {
      $peso.val(formatWeight(variante.weight));
    }
    $largura.val(variante.width);
    $altura.val(variante.height);
    $comprimento.val(variante.length);
    showVarianteBadges(variante);
    $modalVar.modal('show');
    $btnApplyAll.removeClass('open');
  }

  // Atualiza uma variante
  function updateVariante() {
    const varianteSlug = $slug.val();
    const varIndex = getVarianteIndex(varianteSlug);
    if (varIndex !== -1) {
      listVariantesObj[varIndex].sku = $sku.val();
      listVariantesObj[varIndex].aliexpress_sku = $skuAliExpress.val();
      listVariantesObj[varIndex].bar_code = $codigo_barras.val();
      listVariantesObj[varIndex].automatic_stock = $estoque_automatico.is(':checked') ? '1' : '0';
      listVariantesObj[varIndex].quantity = $quantidade_estoque.val();
      listVariantesObj[varIndex].cost_price = $valor_custo.val() != '' ? formatMoneyBD($valor_custo.val()) : 0.0;
      listVariantesObj[varIndex].sale_price = $valor_venda.val() != '' ? formatMoneyBD($valor_venda.val()) : 0.0;
      listVariantesObj[varIndex].old_price = $valor_antigo.val() != '' ? formatMoneyBD($valor_antigo.val()) : 0.0;
      listVariantesObj[varIndex].weight = $peso.val();
      listVariantesObj[varIndex].width = $largura.val();
      listVariantesObj[varIndex].height = $altura.val();
      listVariantesObj[varIndex].length = $comprimento.val();
      if (acaoForm == 'update' && listVariantesObj[varIndex]['id']) {
        const url = $('form.form-produtos').attr('action');
        const dataSend = listVariantesObj[varIndex];
        dataSend['acao'] = 'variantes_update';
        $.ajax({
          type: 'POST',
          url: url,
          data: dataSend,
          dataType: 'json',
        }).always((response) => {
          console.log(response.responseText);
        });
      }
      updateVariantesTable();
      salvarVariantes();
      $modalVar.modal('hide');
      Toast.fire({
        type: 'success',
        title: 'Variante salva com sucesso.',
      });
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Não foi possível salvar as informações da variante.',
      });
    }
    salvando = false;
    $formVarBtn.prop('disabled', false).html('Salvar');
  }

  // Exibe o conjunto de variantes no modal
  function showVarianteBadges(variante) {
    $modalBadgesTitle.text($('#titulo').val() != '' ? $('#titulo').val() : 'Variante');
    $modalBadges.html('');
    /* variante.slug.split('|').forEach((item, index) => {
      $modalBadges.append(
        `<span class="badge badge-pill badge-grey">${opcoesTitulos[index]}: ${variante.title.split('|')[index]}</span>`,
      );
    }); */
    /* $modalBadges.append(`<span class="badge badge-pill badge-grey">${getVarTitView(variante.slug)}</span>`); */
    $modalBadges.append(`<span class="badge badge-pill badge-grey">${variante.title}</span>`);
  }

  // Exibe o conjunto de variantes no título
  function getVarTitView(varianteSlug) {
    let $titulo = '';
    let titArr = [];
    varianteSlug.split('|').forEach((item, index) => {
      let itemValSlug = item.split(':')[1];
      let opcoesValoresItem = opcoesValores[index];
      let itemValTitle = opcoesValoresItem.filter((valItem) => slugify(valItem) === itemValSlug)[0];
      titArr.push(`${opcoesTitulos[index]}: ${itemValTitle}`);
    });
    $titulo = titArr.join(' / ');
    return $titulo;
  }

  // Salva as variantes em JSON em um campo oculto
  function salvarVariantes() {
    $campoJSON.val(JSON.stringify(listVariantesObj));
  }

  // Carrega as variantes cadastradas ao editar o produto
  function loadVariantes() {
    if ($campoJSON.length > 0 && $campoJSON.val() != '') {
      try {
        listVariantesObj = JSON.parse($campoJSON.val());
        //console.log(listVariantesObj);
        //getOpcoesTitulos();
        opcoesValores = getOpcoes();
        updateVariantesTable();
      } catch (error) {
        console.log('Não foi possível carregar as variantes já cadastradas.');
      }
    }
  }
  loadVariantes();

  // Aplica um determinado valor para todas as variantes
  function applyToAllVar(attr, value) {
    //console.log(attr, value);
    listVariantesObj.forEach((variante, index) => {
      // Estoque automático
      if (attr === 'automatic_stock') {
        listVariantesObj[index][attr] = $estoque_automatico.is(':checked') ? '1' : '0';
      }
      // Quantidade
      else if (attr === 'quantity') {
        listVariantesObj[index][attr] = value != '' ? formatMoneyBD(value) : 0.0;
      }
      // Valores
      else if (attr === 'cost_price' || attr === 'sale_price' || attr === 'old_price') {
        listVariantesObj[index][attr] = value != '' ? formatMoneyBD(value) : 0.0;
      }
      // Peso e dimensões
      else if (attr === 'weight' || attr === 'width' || attr === 'height' || attr === 'length') {
        listVariantesObj[index][attr] = value;
      } else {
        return false;
      }
    });
    updateVariantesTable();
    Toast.fire({
      type: 'success',
      title: 'Valor aplicado para todas as variantes.',
    });
    return true;
  }

  // Variáveis
  const $modalVarOptItem = $('#modal-variant-opt-item');
  const $formVarOptItem = $modalVarOptItem.find('form');
  const $optItemTitle = $('#vopti_title');
  const $optItemTitleOld = $('#vopti_title_old');
  const $optItemSlug = $('#vopti_slug');
  const $optOptSlug = $('#vopti_opt_slug');
  const $optOptTitle = $('#vopti_opt_title');
  const $optOptAction = $('#vopti_acao');
  const $btnOptSave = $modalVarOptItem.find('.btn-submit');
  const $btnOptdDel = $modalVarOptItem.find('.btn-del');
  let $itemEdit;
  let $listaUpdateItens;

  // Ao clicar para adicionar um item na opção
  $('body').on('click', '.opt-var-itens-add-item', function () {
    $itemEdit = $(this);
    const opItemEdit = $itemEdit.data('opt');
    $listaUpdateItens = undefined;
    $listaUpdateItens = $itemEdit.parent().parent().find('.tags_update');
    openOptVarItemAdd(opItemEdit);
  });

  // Ao clicar para editar um item da opção
  $('body').on('click', '.opt-var-itens-upd-item:not(.opt-var-itens-add-item)', function () {
    $itemEdit = $(this);
    const itemEdit = $itemEdit.data('opt-item');
    const opItemEdit = $itemEdit.data('opt');
    $listaUpdateItens = undefined;
    $listaUpdateItens = $itemEdit.parent().parent().find('.tags_update');
    openOptVarItemEdit(itemEdit, opItemEdit);
  });

  // Ao clicar para salvar o item
  $btnOptSave.on('click', function (ev) {
    ev.preventDefault();
    handleFormVarItem();
  });
  $formVarOptItem.on('keydown', function (event) {
    if (event.key == 'Enter') {
      event.preventDefault();
      handleFormVarItem();
    }
  });
  function handleFormVarItem() {
    const formAction = $optOptAction.val();
    if (formAction === 'insert') {
      insertVarOptionItem();
    } else if (formAction === 'update') {
      updateVarOptionItem();
    }
  }

  // Ao clicar para remover o item
  $btnOptdDel.on('click', function (ev) {
    ev.preventDefault();
    showConfirm({
      type: 'danger',
      title: 'Confirmar Exclusão',
      text: 'Deseja realmente remover este item? Ao remover, todas as variantes que possuem este atributo serão removidas!',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      callback: remVarOptionItem,
    });
  });

  // Exibe o modal para adicionar um item
  function openOptVarItemAdd(opItemEdit) {
    resetFormVarItemEdit();
    const opItemEditSlug = slugify(opItemEdit);
    $optItemTitle.prev('label').text(opItemEdit);
    $optOptSlug.val(opItemEditSlug);
    $optOptTitle.val(opItemEdit);
    $optOptAction.val('insert');
    $btnOptdDel.hide();
    $modalVarOptItem.find('.modal-title').text('Adicionar item na opção');
    $modalVarOptItem.modal('show');
  }

  // Exibe o modal para edição de um item
  function openOptVarItemEdit(itemEdit, opItemEdit) {
    resetFormVarItemEdit();
    const itemEditSlug = slugify(itemEdit);
    const opItemEditSlug = slugify(opItemEdit);
    $optItemTitle.val(itemEdit);
    $optItemTitle.prev('label').text(opItemEdit);
    $optItemTitleOld.val(itemEdit);
    $optItemSlug.val(itemEditSlug);
    $optOptSlug.val(opItemEditSlug);
    $optOptTitle.val(opItemEdit);
    $optOptAction.val('update');
    $btnOptdDel.show();
    $modalVarOptItem.find('.modal-title').text('Editar item da opção');
    $modalVarOptItem.modal('show');
  }

  // Reseta o form de edição
  function resetFormVarItemEdit() {
    $optItemTitle.val('');
    $optItemTitleOld.val('');
    $optItemTitle.prev('label').text('');
    $optItemSlug.val('');
    $optOptSlug.val('');
    $optOptTitle.val('');
    $optOptAction.val('');
    $formVarOptItem.parsley().reset();
  }

  // Adiciona um item da opção
  function insertVarOptionItem() {
    const newTitle = $optItemTitle.val();
    const newTitleSlug = slugify(newTitle);
    const optTitle = $optOptTitle.val();
    const optSlug = $optOptSlug.val();
    if (newTitle) {
      let listaUpdateItens = $listaUpdateItens.val();
      listaUpdateItens = listaUpdateItens != '' ? listaUpdateItens.split(',') : [];
      if (!verifyList(listaUpdateItens, newTitle)) {
        listaUpdateItens.push(newTitle);
        $listaUpdateItens.val(listaUpdateItens.join(','));
        $listaUpdateItens.trigger('change');
        $(`<div class="opt-var-itens-upd-item" data-opt="${optTitle}" data-opt-item="${newTitle}" title="Clique para editar">
        <div class="opt-var-itens-upd-item-desc">${newTitle}</div>
        <div class="opt-var-itens-upd-item-edit"><i class="las la-pen"></i></div>
        </div>`).insertBefore($itemEdit);
        $modalVarOptItem.modal('hide');
        Toast.fire({
          type: 'success',
          title: 'Item adicionado com sucesso.',
        });
      } else {
        Toast.fire({
          type: 'warning',
          title: 'Já existe outro item com o mesmo nome.',
        });
      }
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Digite um item válido.',
      });
    }
  }

  // Atualiza o item da opção
  function updateVarOptionItem() {
    const oldTitle = $optItemTitleOld.val();
    const oldTitleSlug = slugify(oldTitle);
    const newTitle = $optItemTitle.val();
    const newTitleSlug = slugify(newTitle);
    const optTitle = $optOptTitle.val();
    const optSlug = $optOptSlug.val();
    if (oldTitle !== newTitle) {
      const listaUpdateItens = $listaUpdateItens.val().split(',');
      const oldTitleKey = listaUpdateItens.indexOf(oldTitle);
      if (!verifyList(listaUpdateItens, newTitle, oldTitle)) {
        if (oldTitleKey !== -1) {
          $itemEdit.find('.opt-var-itens-upd-item-desc').text(newTitle);
          $itemEdit.data('opt-item', newTitle);
          listaUpdateItens[oldTitleKey] = newTitle;
          $listaUpdateItens.val(listaUpdateItens.join(','));
          updateItemTitleVariants('item', oldTitle, newTitle, optTitle);
          $modalVarOptItem.modal('hide');
          Toast.fire({
            type: 'success',
            title: 'Item atualizado com sucesso.',
          });
        } else {
          Toast.fire({
            type: 'error',
            title: 'Não foi possível atualizar este item.',
          });
        }
      } else {
        Toast.fire({
          type: 'warning',
          title: 'Já existe outro item com o mesmo nome.',
        });
      }
    } else {
      $modalVarOptItem.modal('hide');
    }
  }

  // Verifica se um item já está na lista
  function verifyList(listItens, item, oldTitleEdit = false) {
    return listItens.some((listItem) => {
      if (oldTitleEdit) {
        return oldTitleEdit !== listItem && slugify(listItem) === slugify(item);
      } else {
        return slugify(listItem) === slugify(item);
      }
    });
  }

  // Remove o item da opção
  function remVarOptionItem() {
    const oldTitle = $optItemTitleOld.val();
    const oldTitleSlug = slugify(oldTitle);
    const optSlug = $optOptSlug.val();
    const listaUpdateItens = $listaUpdateItens.val().split(',');
    const oldTitleKey = listaUpdateItens.indexOf(oldTitle);
    if (oldTitleKey !== -1) {
      $itemEdit.remove();
      listaUpdateItens.splice(oldTitleKey, 1);
      $listaUpdateItens.val(listaUpdateItens.join(','));
      $listaUpdateItens.trigger('change');
      $modalVarOptItem.modal('hide');
      Toast.fire({
        type: 'success',
        title: 'Item removido com sucesso.',
      });
    } else {
      Toast.fire({
        type: 'error',
        title: 'Não foi possível remover o item.',
      });
    }
  }
})();

// Kits
(function () {
  'use strict';

  // Variáveis
  const $btnAdd = $('.btn-add-kit');
  const $btnAddWrp = $('.btn-add-kit-wrp');
  const $tableKits = $('.table-kits');
  const $tableKitsWrp = $('.table-kits-wrp');
  const $listKits = $('[data-list="kits_lista"]');
  const $modalKit = $('#modal-kit');
  const $formKit = $('#form-kit');
  const $formBtn = $formKit.find('.btn-submit');
  const $titulo = $('#kit_titulo');
  const $sku = $('#kit_sku');
  const $kitItems = $('#kits_items');
  const $skuAliExpress = $('#kit_aliexpress_sku');
  const $codigo_barras = $('#kit_codigo_barras');
  const $estoque_automatico = $('#kit_estoque_automatico');
  const $quantidade_estoque = $('#kit_quantidade_estoque');
  const $valor_custo = $('#kit_valor_custo');
  const $valor_venda = $('#kit_valor_venda');
  const $valor_antigo = $('#kit_valor_antigo');
  const $peso = $('#kit_peso');
  const $largura = $('#kit_largura');
  const $altura = $('#kit_altura');
  const $comprimento = $('#kit_comprimento');
  const $idUpdate = $('#kit_update');
  const $btnApplyAll = $('.var-btn-apply-all2');
  const $campoJSON = $('#kits_json');
  const limitKits = 6;
  let listKits = [];
  let salvando = false;
  let actionCur;
  const $dzInfos = $('#dz_fotos_infos');
  const acaoForm =
    $('.form-produtos input[name="acao"]').length > 0 ? $('.form-produtos input[name="acao"]').val() : false;

  // Ao clicar para adicionar um kit
  $btnAdd.on('click', function (ev) {
    ev.preventDefault();
    if (verifyLimitKits()) {
      showModalKit();
    }
  });

  // Ao clicar para salvar um novo kit
  $formBtn.on('click', function (ev) {
    ev.preventDefault();
    if (verifyKitSku($sku.val(), getKitIndex($idUpdate.val()))) {
      if ($valor_venda.val() != '' && formatMoneyBD($valor_venda.val()) > 0) {
        if (!salvando) {
          $formBtn.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
          $formKit
            .parsley()
            .whenValidate()
            .done(function () {
              if (actionCur === 'insert') {
                addKit();
              } else {
                updateKit();
              }
            })
            .fail(function () {
              $formBtn.prop('disabled', false).html('Salvar');
            });
        }
      } else {
        Toast.fire({
          type: 'warning',
          title: 'Informe o preço de venda deste combo.',
        });
      }
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Já existe outro produto com este mesmo código de SKU.',
      });
    }
  });

  // Ao clicar em um kit para editar
  $listKits.on('click', '[data-edit-kit]', function (ev) {
    ev.preventDefault();
    resetFormKit();
    showModalKit('update', $(this).data('edit-kit'));
  });

  // Ao clicar em um kit para remover
  $listKits.on('click', '[data-rem-kit]', function (ev) {
    ev.preventDefault();
    const kitId = $(this).data('rem-kit');
    showConfirm({
      type: 'danger',
      title: 'Confirmar Remoção',
      text: 'Deseja remover este combo?',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      callback: function () {
        removeKit(kitId);
      },
    });
  });

  // Fix para o campo sku da variante
  if ($('#kit_sku').length > 0) {
    $('#kit_sku')
      .parsley()
      .on('field:validate', function () {
        if (!salvando) {
          $formBtn.prop('disabled', true);
        }
      })
      .on('field:validated', function () {
        if (!salvando) {
          $formBtn.prop('disabled', false);
        }
      });
  }

  // Ao alterar um campo do modal do kit (Exibe a opção de aplicar o valor para todos)
  function camposApplyAllEvent() {
    const $camposApplyAll = $('.var-apply-all2');
    $camposApplyAll.on('change', function () {
      const $btnApply = $(`.var-btn-apply-all2[data-input="${$(this).attr('name')}"]`);
      if (!$btnApply.hasClass('open')) {
        $btnApply.addClass('open');
        /* setTimeout(() => {
          $btnApply.removeClass('open');
        }, 5000); */
      }
    });
  }

  function hideApplyAll() {
    const $btnApplyAll = $('.var-btn-apply-all2');
    $btnApplyAll.removeClass('open');
  }

  // Verifica o limite dos kits
  function verifyLimitKits() {
    return listKits.length < limitKits;
  }
  function handleLimitKits() {
    if (!verifyLimitKits()) {
      $btnAddWrp.removeClass('d-flex').addClass('d-none');
    } else {
      $btnAddWrp.removeClass('d-none').addClass('d-flex');
    }
  }

  // Popula a tabela de kits
  function updateKitsTable() {
    formListClear($listKits);
    if (listKits.length > 0) {
      $tableKitsWrp.show();
    } else {
      $tableKitsWrp.hide();
    }
    listKits.forEach((kit) => {
      const tituloView = kit.title;
      const skuView = kit.sku ? kit.sku : '-';
      const qtdeView = kit.automatic_stock == '1' ? kit.quantity : '∞';
      const fotoView = getKitImg(kit.image_id);
      const valorView = 'R$ ' + formatMoneyBR(kit.sale_price);
      const $kit = `
      <tr data-item="${kit.id}" data-kit="${kit.id}">
        <td data-label="Foto"><img src="${fotoView}" class="img-fluid border rounded" data-handle-kit-img="${kit.id}" width="50px"></td>
        <td data-label="Combo"><div class="variante-titx">${tituloView}</div></td>
        <td data-label="Preço">${valorView}</td>
        <td data-label="SKU"><div class="truncate-text" style="width: 100px;">${skuView}</div></td>
        <td data-label="Quantidade">${qtdeView}</td>
        <td>
          <div class="table-options no-hover">
            <a href="#" class="btn btn-sm btn-default" data-toggle="tooltip" data-placement="bottom" title="Editar" data-edit-kit="${kit.id}"><i class="las la-pen"></i></a>
            <a href="#" class="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="bottom" title="Remover" data-rem-kit="${kit.id}"><i class="las la-trash"></i></a>
          </div>
        </td>
      </tr>`;
      $listKits.append($kit);
    });
    initTooltips();
    initInputMask();
    initSpinners();
    camposApplyAllEvent();
    handleLimitKits();
  }

  // Retorna a imagem do kit
  function getKitImg(fotoID) {
    let thumb = imgEmpty;
    if (fotoID && $dzInfos.val() != '') {
      let imagesList = $dzInfos.val();
      imagesList = JSON.parse(imagesList);
      let imgThumb = imagesList.filter((img) => img.id === fotoID);
      if (imgThumb.length > 0) {
        thumb = imgThumb[0].image_small;
      }
    }
    return thumb;
  }

  // Verifica se existe algum combo com o mesmo SKU
  function verifyKitSku(sku, indexK) {
    return !listKits.some((item, index) => index !== indexK && item.sku === sku);
  }

  // Retorna o kit com base no id
  function getKit(kitId) {
    if (kitId) {
      kitId = kitId + '';
      return listKits.filter((item) => item.id === kitId)[0];
    }
    return false;
  }

  // Retorna o índice de um kit
  function getKitIndex(kitId) {
    if (kitId) {
      kitId = kitId + '';
      return listKits.findIndex((item) => item.id === kitId);
    }
    return false;
  }

  // Exibe o modal para cadastro do kit
  function showModalKit(action = 'insert', idKit = false) {
    resetFormKit();
    actionCur = action;
    $btnApplyAll.removeClass('open');
    camposApplyAllEvent();
    if (action === 'insert') {
      $modalKit.find('.modal-title').text('Cadastrar combo');
    } else if (action === 'update') {
      $modalKit.find('.modal-title').text('Editar combo');
      populaFormKit(idKit);
    }
    $modalKit.modal('show');
  }

  // Popula o formulário para alteração das informações do kit
  function populaFormKit(idKit) {
    const kit = getKit(idKit);
    //console.log(kit);
    $idUpdate.val(kit.id);
    $sku.val(kit.sku);
    $kitItems.val(kit.kits_items);
    $skuAliExpress.val(kit.aliexpress_sku);
    $titulo.val(kit.title);
    $codigo_barras.val(kit.bar_code);
    $estoque_automatico.prop('checked', kit.automatic_stock == '1').trigger('change');
    $quantidade_estoque.val(kit.quantity);
    $valor_custo.val(formatMoneyBR(kit.cost_price));
    $valor_venda.val(formatMoneyBR(kit.sale_price));
    $valor_antigo.val(formatMoneyBR(kit.old_price));
    if (isNaN(kit.weight)) {
      $peso.val(kit.weight);
    } else {
      $peso.val(formatWeight(kit.weight));
    }
    $largura.val(kit.width);
    $altura.val(kit.height);
    $comprimento.val(kit.length);
  }

  // Ao clicar na opção de aplicar o valor para todos os kits
  $btnApplyAll.on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    if ($btn.hasClass('open')) {
      const inputName = $btn.data('input');
      const $input = $formKit.find(`[name="${inputName}"]`);
      if ($input.length > 0) {
        showConfirm({
          type: 'default',
          title: 'Confirmação',
          text: 'Deseja aplicar o valor para todos os combos?',
          confirmButtonText: 'Aplicar',
          cancelButtonText: 'Cancelar',
          callback: function () {
            applyToAllVar(inputName, $input.val());
          },
        });
      }
    }
  });

  // Reseta o formulário do kit
  function resetFormKit() {
    actionCur = undefined;
    $titulo.val('');
    $sku.val('');
    $kitItems.val('1');
    $skuAliExpress.val('');
    $codigo_barras.val('');
    $estoque_automatico.prop('checked', false);
    $quantidade_estoque.val('0');
    $valor_custo.val('');
    $valor_venda.val('');
    $valor_antigo.val('');
    $peso.val('');
    $largura.val('');
    $altura.val('');
    $comprimento.val('');
    $idUpdate.val('');
    $formKit.parsley().reset();
    $formBtn.prop('disabled', false).html('Salvar');
    hideApplyAll();
    salvando = false;
  }

  // Adiciona um novo combo
  function addKit() {
    const itemKit = {
      id: formListGenerateID($listKits) + '',
      title: $titulo.val(),
      sku: $sku.val(),
      aliexpress_sku: $skuAliExpress.val(),
      bar_code: $codigo_barras.val(),
      automatic_stock: $estoque_automatico.is(':checked') ? '1' : '0',
      quantity: $quantidade_estoque.val(),
      cost_price: $valor_custo.val() != '' ? formatMoneyBD($valor_custo.val()) : 0.0,
      sale_price: $valor_venda.val() != '' ? formatMoneyBD($valor_venda.val()) : 0.0,
      old_price: $valor_antigo.val() != '' ? formatMoneyBD($valor_antigo.val()) : 0.0,
      weight: $peso.val(),
      width: $largura.val(),
      height: $altura.val(),
      length: $comprimento.val(),
      kits_items: $kitItems.val(),
      new: 1,
    };
    listKits.push(itemKit);
    updateKitsTable();
    salvarKits();
    $modalKit.modal('hide');
    resetFormKit();
    Toast.fire({
      type: 'success',
      title: 'Combo adicionado com sucesso.',
    });
  }

  // Atualiza um combo
  function updateKit() {
    const kitId = $idUpdate.val();
    const kitIndex = getKitIndex(kitId);
    if (kitIndex !== -1) {
      listKits[kitIndex].title = $titulo.val();
      listKits[kitIndex].sku = $sku.val();
      listKits[kitIndex].aliexpress_sku = $skuAliExpress.val();
      listKits[kitIndex].bar_code = $codigo_barras.val();
      listKits[kitIndex].automatic_stock = $estoque_automatico.is(':checked') ? '1' : '0';
      listKits[kitIndex].quantity = $quantidade_estoque.val();
      listKits[kitIndex].cost_price = $valor_custo.val() != '' ? formatMoneyBD($valor_custo.val()) : 0.0;
      listKits[kitIndex].sale_price = $valor_venda.val() != '' ? formatMoneyBD($valor_venda.val()) : 0.0;
      listKits[kitIndex].old_price = $valor_antigo.val() != '' ? formatMoneyBD($valor_antigo.val()) : 0.0;
      listKits[kitIndex].weight = $peso.val();
      listKits[kitIndex].width = $largura.val();
      listKits[kitIndex].height = $altura.val();
      listKits[kitIndex].length = $comprimento.val();
      listKits[kitIndex].kits_items = $kitItems.val();
      updateKitsTable();
      salvarKits();
      $modalKit.modal('hide');
      resetFormKit();
      Toast.fire({
        type: 'success',
        title: 'Combo atualizado com sucesso.',
      });
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Não foi possível salvar as informações do combo.',
      });
    }
  }

  // Remove um kit
  function removeKit(kitId) {
    const kitIndex = getKitIndex(kitId);
    if (kitIndex !== -1) {
      listKits.splice(kitIndex, 1);
      updateKitsTable();
      salvarKits();
      Toast.fire({
        type: 'success',
        title: 'Combo removido com sucesso.',
      });
    }
  }

  // Aplica um determinado valor para todos os kits
  function applyToAllVar(attr, value) {
    //console.log(attr, value);
    listKits.forEach((kit, index) => {
      // Estoque automático
      if (attr === 'automatic_stock') {
        listKits[index][attr] = $estoque_automatico.is(':checked') ? '1' : '0';
      }
      // Quantidade
      else if (attr === 'quantity') {
        listKits[index][attr] = value != '' ? formatMoneyBD(value) : 0.0;
      }
      // Valores
      else if (attr === 'cost_price' || attr === 'sale_price' || attr === 'old_price') {
        listKits[index][attr] = value != '' ? formatMoneyBD(value) : 0.0;
      }
      // Peso e dimensões
      else if (attr === 'weight' || attr === 'width' || attr === 'height' || attr === 'length') {
        listKits[index][attr] = value;
      } else {
        return false;
      }
    });
    updateKitsTable();
    Toast.fire({
      type: 'success',
      title: 'Valor aplicado para todos os combos.',
    });
    return true;
  }

  // Carrega os kits cadastrados ao editar o produto
  function loadKits() {
    if ($campoJSON.length > 0 && $campoJSON.val() != '') {
      try {
        listKits = JSON.parse($campoJSON.val());
        //console.log(listKits);
        updateKitsTable();
      } catch (error) {
        console.log('Não foi possível carregar os kits já cadastrados.');
      }
    }
  }
  loadKits();

  // Salva os kits em JSON em um campo oculto
  function salvarKits() {
    $campoJSON.val(JSON.stringify(listKits));
  }

  // Ao clicar para alterar a imagem do kit
  $listKits.on('click', 'img[data-handle-kit-img]', function (ev) {
    ev.preventDefault();
    const kitId = $(this).data('handle-kit-img');
    $('#kit_id').val(kitId);
    $('#dz-gallery-kit').find('input[name="kit_img"]').prop('checked', false);
    $('#modal-img-kit').modal('show');
  });

  // Ao clicar para aplicar a imagem do combo selecionado
  $('.btn-save-img-kit').on('click', function (ev) {
    ev.preventDefault();
    // Verifica se existe alguma foto selecionada
    if ($('#dz-gallery-kit').find('input[name="kit_img"]:checked').length > 0) {
      const kitId = $('#kit_id').val();
      const fotoID = $('#dz-gallery-kit').find('input[name="kit_img"]:checked').val();
      listKits[getKitIndex(kitId)].image_id = fotoID;
      updateKitsTable();
      salvarKits();
      $('#modal-img-kit').modal('hide');
    } else {
      Toast.fire({
        type: 'warning',
        title: 'Selecione uma imagem para o combo.',
      });
    }
  });
  $dzInfos.on('change', updateKitsTable);
})();

(function () {
  'use strict';
  // Verificações das variantes e kits antes de enviar o formulário
  $('.form-produtos .btn-submit').on('click', function (ev) {
    ev.preventDefault();
    if ($('input[name="has_variant"]:checked').val() == '1' || $('input[name="has_kits"]:checked').val() == '1') {
      if ($('input[name="has_variant"]:checked').val() == '1') {
        let listVariantesObj = $('#variantes_json').val() ? JSON.parse($('#variantes_json').val()) : [];
        // Verifica se as variantes foram criadas
        if (listVariantesObj.length > 0) {
          // Verifica se ha alguma variante sem preço
          if (listVariantesObj.some((item) => item.sale_price == 0)) {
            Toast.fire({
              type: 'warning',
              title: 'Há uma ou mais variantes sem o preço de venda cadastrado.',
            });
          } else {
            $('.form-produtos').submit();
          }
          // Verifica se existe algum atributo de variante de título
          if ($('.form-control.tags_tit').length > 0) {
            let numSemTit = 0;
            $('.form-control.tags_tit').each(function () {
              if (!$(this).val()) {
                $(this).addClass('danger');
                numSemTit++;
              } else {
                $(this).removeClass('danger');
              }
            });
            if (numSemTit > 0) {
              Toast.fire({
                type: 'warning',
                title: 'Por favor, preencha o campo de nome da opção das variantes.',
              });
            }
          }
        } else {
          Toast.fire({
            type: 'warning',
            title: 'É necessário cadastrar pelo menos uma variante!',
          });
        }
      }
      if ($('input[name="has_kits"]:checked').val() == '1') {
        let listKits = $('#kits_json').val() ? JSON.parse($('#kits_json').val()) : [];
        // Verifica se os kits foram criados
        if (listKits.length > 0) {
          // Verifica se ha algum kit sem preço
          if (listKits.some((item) => item.sale_price == 0)) {
            Toast.fire({
              type: 'warning',
              title: 'Há um ou mais combos sem o preço de venda cadastrado.',
            });
          } else {
            $('.form-produtos').submit();
          }
        } else {
          Toast.fire({
            type: 'warning',
            title: 'É necessário cadastrar pelo menos um combo!',
          });
        }
      }
    } else {
      $('.form-produtos').submit();
    }
  });
})();

// Alterna a opção de estoque automático
(function () {
  'use strict';

  // Variáveis
  const $estoqueAutomatico = $('input[name="automatic_stock"]');

  // Altera a opção
  $estoqueAutomatico.on('change', handleEstoqueAuto);
  handleEstoqueAuto();
  function handleEstoqueAuto() {
    $estoqueAutomatico.each(function () {
      const $el = $(this);
      const $campoQuantidadeWrp = $($el.data('qtde-wrp'));
      const $campoQuantidade = $campoQuantidadeWrp.find('input[name="quantity"]');
      if ($el.is(':checked')) {
        $campoQuantidadeWrp.show();
        $campoQuantidade.prop('disabled', false);
      } else {
        $campoQuantidadeWrp.hide();
        $campoQuantidade.prop('disabled', true);
      }
    });
  }
})();

// Vídeo
(function () {
  'use strict';

  // Variáveis
  const $videoURL = $('#video_url');
  const $videoID = $('#video_id');
  const $videoPlataforma = $('#video_plataforma');
  const $videoIframe = $('.prod-video-iframe');

  if ($videoURL.length > 0) {
    handleVideo();
    $videoURL.on('change', handleVideo);
  }

  // Evento ao alterar a url do vídeo
  function handleVideo() {
    const videoURL = $videoURL.val().trim();
    $videoURL.val('');
    $videoID.val('');
    $videoIframe.html('');
    $videoIframe.removeClass('mt-3');
    $videoIframe.addClass('d-none');
    if (videoURL != '') {
      const videoObj = parseVideo(videoURL);
      if (videoObj.id) {
        $videoURL.val(videoURL);
        $videoID.val(videoObj.id);
        $videoPlataforma.val(videoObj.plataforma);
        $videoIframe.append(createVideo(videoURL));
        $videoIframe.addClass('mt-3');
        $videoIframe.removeClass('d-none');
      } else {
        Toast.fire({
          type: 'warning',
          title:
            'Não foi possível carregar o vídeo. Verifique se o link informado está correto ou se o vídeo possui permissão para ser incorporado em outros sites.',
        });
      }
    }
  }

  // Obtém o ID de um vídeo do Youtube através da URL
  /* function YouTubeGetID(url) {
    url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  } */
  function YouTubeGetID(url) {
    if (url.includes('/shorts/')) {
      // Se a URL contiver "/shorts/", processa a parte relevante
      const parts = url.split('/shorts/');
      return parts.length === 2 ? parts[1].split('?')[0] : undefined;
    } else {
      // Caso contrário, continua com a lógica original
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }
  }

  // Obtém o ID de um vídeo do Vimeo através da URL
  function VimeoGetID(url) {
    var id = false;
    $.ajax({
      url: 'https://vimeo.com/api/oembed.json?url=' + url,
      async: false,
      success: function (response) {
        if (response.video_id) {
          id = response.video_id;
        }
      },
    });
    return id;
  }

  // Retorna um objeto com as informações do vídeo
  function parseVideo(url) {
    const videoObj = {};
    // Verifica a plataforma do vídeo
    if (/youtu/.test(url)) {
      videoObj.plataforma = 'youtube';
      videoObj.id = YouTubeGetID(url);
    } else if (/vimeo/.test(url)) {
      videoObj.plataforma = 'vimeo';
      videoObj.id = VimeoGetID(url);
    }
    return videoObj;
  }

  // Cria um elemento Iframe de vídeo
  function createVideo(url) {
    const videoObj = parseVideo(url);
    let $iframe;
    if (videoObj.plataforma == 'youtube') {
      $iframe = `<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${videoObj.id}?controls=0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    } else if (videoObj.plataforma == 'vimeo') {
      $iframe = `<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="https://player.vimeo.com/video/${videoObj.id}?title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`;
    }
    return $iframe;
  }
})();

// Exibe/Oculta kits
(function () {
  'use strict';
  $('input[name="has_variant"]').on('change', handleFormKitsWrp);
  $('#possui_kits').on('change', handleFormKits);
  handleFormKitsWrp();
  function handleFormKitsWrp() {
    const $camposWrp = $('.campos-kits-wrp');
    if ($('input[name="has_variant"]:checked').val() != '1') {
      $camposWrp.show();
    } else {
      $camposWrp.hide();
      $('#possui_kits').prop('checked', false);
    }
    if ($('#possui_kits').length > 0) {
      $('#possui_kits').trigger('change');
    }
  }
  function handleFormKits() {
    const $camposWrp = $('.campos-kits');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('#possui_kits').is(':checked')) {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
    formListUpdate($('[data-list="kits"]'));
    $('#aliexpress_status').trigger('change');
  }
})();

// Exibe/Oculta preços
(function () {
  'use strict';
  $('input[name="has_variant"], input[name="has_kits"]').on('change', handleFormPrecos);
  handleFormPrecos();
  function handleFormPrecos() {
    const $camposWrp = $('.campos-precos-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('input[name="has_variant"]:checked').val() != '1' && $('input[name="has_kits"]:checked').val() != '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Dropshipping
(function () {
  'use strict';
  // AliExpress
  $('#aliexpress_status').on('change', handleFormAliexpress);
  handleFormAliexpress();
  function handleFormAliexpress() {
    const $camposWrp = $('.campos-aliexpress');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('#aliexpress_status').is(':checked')) {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
      if ($('input[name="has_variant"]:checked').val() == '1' || $('input[name="has_kits"]:checked').val() == '1') {
        $('#aliexpress_sku').prop('disabled', true);
        $('#aliexpress_sku').prop('required', false);
      }
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
  // Wiio
  $('#wiio_status').on('change', handleFormWiio);
  handleFormWiio();
  function handleFormWiio() {
    const $camposWrp = $('.campos-wiio');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('#wiio_status').is(':checked')) {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Estoque
(function () {
  'use strict';
  $('input[name="has_variant"], input[name="has_kits"]').on('change', handleFormEstoqueWrp);
  handleFormEstoqueWrp();
  function handleFormEstoqueWrp() {
    const $camposWrp = $('.campos-estoque-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea').not('#aliexpress_sku');
    const $camposInputsRequired = $camposWrp
      .find('input[data-required="true"], select[data-required="true"], textarea[data-required="true"]')
      .not('#aliexpress_sku');
    if ($('input[name="has_variant"]:checked').val() != '1' && $('input[name="has_kits"]:checked').val() != '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.val('');
      $camposInputs.prop('required', false);
    }
    $('#aliexpress_status').trigger('change');
  }
})();

// Altera tipo produto
(function () {
  'use strict';
  $('input[name="product_type"]').on('change', handleFormTipoProd);
  handleFormTipoProd();
  function handleFormTipoProd() {
    if ($('input[name="product_type"]:checked').val() == 'digital') {
      $('#tipo_frete').prop('disabled', true);
      $('#tipo_frete').prop('required', false);
      $('#tipo_frete').val('gratis');
    } else {
      $('#tipo_frete').prop('disabled', false);
      //$('#tipo_frete').prop('required', true);
    }
    if ($('#tipo_frete').length > 0) {
      $('#tipo_frete').trigger('change').parsley().reset();
    }
  }
})();

// Exibe/Oculta Valor do Frete
(function () {
  'use strict';
  $('#tipo_frete').on('change', handleFormValorFrete);
  $('#tipo_frete').on('change', handleFormPrazoFrete);
  handleFormValorFrete();
  handleFormPrazoFrete();
  function handleFormValorFrete() {
    const $camposWrp = $('.campos-valor-frete');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('#tipo_frete').val() == 'fixo') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
  function handleFormPrazoFrete() {
    const $camposWrp = $('.campos-prazo-frete');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if (
      $('#tipo_frete').val() == 'fixo' ||
      ($('#tipo_frete').val() == 'gratis' && $('input[name="product_type"]:checked').val() != 'digital')
    ) {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Prazo de entrega
/* (function () {
  'use strict';
  $('#tipo_frete').on('change', handleFormFreteFixoWrp);
  handleFormFreteFixoWrp();
  function handleFormFreteFixoWrp() {
    const $camposWrp = $('.campos-frete-fixo');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('#tipo_frete').val() == 'fixo') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})(); */

// Exibe/Oculta Dimensões
(function () {
  'use strict';
  $('input[name="has_variant"], input[name="has_kits"], #tipo_frete').on('change', handleFormDimensoesWrp);
  handleFormDimensoesWrp();
  function handleFormDimensoesWrp() {
    const $camposWrp = $('.campos-dimensoes-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    /* if (
      $('input[name="has_variant"]:checked').val() != '1' &&
      $('input[name="has_kits"]:checked').val() != '1' &&
      $('#tipo_frete').val() != 'gratis'
    ) { */
    if ($('input[name="has_variant"]:checked').val() != '1' && $('input[name="has_kits"]:checked').val() != '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Dimensões (Variantes)
(function () {
  'use strict';
  $('input[name="has_variant"], input[name="has_kits"], #tipo_frete').on('change', handleFormDimensoesVarWrp);
  handleFormDimensoesVarWrp();
  function handleFormDimensoesVarWrp() {
    const $camposWrp = $('.campos-dimensoes-var-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    /* if (
      $('input[name="has_variant"]:checked').val() == '1' &&
      $('input[name="has_variant"]:checked').val() != '1' &&
      $('#tipo_frete').val() != 'gratis'
    ) { */
    if ($('input[name="has_variant"]:checked').val() == '1' && $('input[name="has_kits"]:checked').val() != '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Dimensões (Kits)
(function () {
  'use strict';
  $('input[name="has_variant"], input[name="has_kits"], #tipo_frete').on('change', handleFormDimensoesKitWrp);
  handleFormDimensoesKitWrp();
  function handleFormDimensoesKitWrp() {
    const $camposWrp = $('.campos-dimensoes-kit-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    /* if (
      $('input[name="has_variant"]:checked').val() != '1' &&
      $('input[name="has_kits"]:checked').val() == '1' &&
      $('#tipo_frete').val() != 'gratis'
    ) { */
    if ($('input[name="has_variant"]:checked').val() != '1' && $('input[name="has_kits"]:checked').val() == '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

// Exibe/Oculta Variantes
(function () {
  'use strict';
  $('input[name="has_variant"]').on('change', handleFormVariantesWrp);
  handleFormVariantesWrp();
  function handleFormVariantesWrp() {
    const $camposWrp = $('.campos-variantes-wrp');
    const $camposInputs = $camposWrp.find('input, select, textarea');
    const $camposInputsRequired = $camposWrp.find(
      'input[data-required="true"], select[data-required="true"], textarea[data-required="true"]',
    );
    if ($('input[name="has_variant"]:checked').val() == '1') {
      $camposWrp.show();
      $camposInputs.prop('disabled', false);
      $camposInputsRequired.prop('required', true);
    } else {
      $camposWrp.hide();
      $camposInputs.prop('disabled', true);
      $camposInputs.prop('required', false);
    }
  }
})();

(function () {
  'use strict';
  const $varTipoNovo = $('#variantes_tipo_novo');
  if ($varTipoNovo.length > 0) {
    $('input[name="has_variant"], input[name="has_kits"]').on('change', handleTipoVars);
    handleTipoVars();
    function handleTipoVars() {
      if ($('input[name="has_variant"]:checked').val() == '1') {
        $varTipoNovo.val('variants');
      } else if ($('input[name="has_kits"]:checked').val() == '1') {
        $varTipoNovo.val('kits');
      } else {
        $varTipoNovo.val('unico');
      }
    }
  }
})();
